import { render, staticRenderFns } from "./CrudFormFieldset.vue?vue&type=template&id=2f2b9d54&lang=pug&"
import script from "./CrudFormFieldset.vue?vue&type=script&lang=js&"
export * from "./CrudFormFieldset.vue?vue&type=script&lang=js&"
import style0 from "./CrudFormFieldset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CrudFormFieldset.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VFlex,
  VLayout,
})
